export const GET_DIARIES_LIST_DATA = "GET_DIARIES_LIST_DATA";
export const GET_TODO_LIST_DATA_SUCCESS = "GET_TODO_LIST_DATA_SUCCESS";
export const UPDATE_TODO_LIST_DATA_SUCCESS = "UPDATE_TODO_LIST_DATA_SUCCESS";

export const GET_TODO_WEEK_DATA = "GET_TODO_WEEK_DATA";
export const GET_TODO_MONTH_DATA = "GET_TODO_MONTH_DATA";

export const UPDATE_TODO_WEEK_DATA = "UPDATE_TODO_WEEK_DATA";
export const UPDATE_TODO_MONTH_DATA = "UPDATE_TODO_MONTH_DATA";

export const GET_TODO_VIEW_DATA_SUCCESS = "GET_TODO_VIEW_DATA_SUCCESS";
export const CHANGE_ACTIVE_TAB="CHANGE_ACTIVE_TAB";
export const CHANGE_VIEW_ACTIVE_TAB="CHANGE_VIEW_ACTIVE_TAB";

export const GET_DIARY_LOGS = "GET_DIARY_LOGS";
export const GET_DIARY_LOGS_SUCCESS = "GET_DIARY_LOGS_SUCCESS";
export const CHANGE_SELECTED_DIARY = "CHANGE_SELECTED_DIARY";
export const RESET_LISTING_DATA = "RESET_LISTING_DATA";
export const RESET_LISTING_LOG_DATA = "RESET_LISTING_LOG_DATA";
export const GET_DIARY_DETAIL_REQUEST = "GET_DIARY_DETAIL_REQUEST";
export const GET_DIARY_DETAIL_SUCCESS = "GET_DIARY_DETAIL_SUCCESS";

export const COMPLETE_DIARY_REQUEST = "COMPLETE_DIARY_REQUEST";
export const COMPLETE_DIARY_SUCCESS_LISTING = "COMPLETE_DIARY_SUCCESS_LISTING";
export const COMPLETE_DIARY_SUCCESS_VIEW = "COMPLETE_DIARY_SUCCESS_VIEW";

export const CANCEL_DIARY_REQUEST = "CANCEL_DIARY_REQUEST";
export const CANCEL_DIARY_SUCCESS_LISTING = "CANCEL_DIARY_SUCCESS_LISTING";
export const CANCEL_DIARY_SUCCESS_VIEW = "CANCEL_DIARY_SUCCESS_VIEW";

export const TOGGLE_VIEW = "TOGGLE_VIEW";
export const SHOW_MORE_CALENDAR_VIEW = "SHOW_MORE_CALENDAR_VIEW";
export const FETCH_DIARY_INFO = "FETCH_DIARY_INFO";
export const FETCH_DIARY_INFO_SUCCESS = "FETCH_DIARY_INFO_SUCCESS";

export const GET_SPONSORS_REQUEST = "GET_SPONSORS_REQUEST";
export const GET_SPONSORS_SUCCESS = "GET_SPONSORS_SUCCESS";

export const CHANGE_DIARY_OWNER_REQUEST = "CHANGE_DIARY_OWNER_REQUEST";
export const CHANGE_DIARY_OWNER_SUCCESS = "CHANGE_DIARY_OWNER_SUCCESS";

export const GET_DIARY_LOGS_DAY_VIEW_SUCCESS = "GET_DIARY_LOGS_DAY_VIEW_SUCCESS";

export const UPDATE_CAPTION_TODO_REQUEST = "UPDATE_CAPTION_TODO_REQUEST";
export const UPDATE_CAPTION_TODOLIST_SUCCESS = "UPDATE_CAPTION_TODOLIST_SUCCESS";
export const UPDATE_CAPTION_TODOVIEW_SUCCESS = "UPDATE_CAPTION_TODOVIEW_SUCCESS";

export const RESET_DIARY_VIEW_DATA="RESET_DIARY_VIEW_DATA";
export const RESET_DIARY_VIEW_DIARYINFO_DATA="RESET_DIARY_VIEW_DIARYINFO_DATA";

export const SHOW_LEFT_LISTING_LOADER="SHOW_LEFT_LISTING_LOADER";
export const HIDE_LEFT_LISTING_LOADER="HIDE_LEFT_LISTING_LOADER";

export const SHOW_RIGHT_LISTING_LOADER="SHOW_RIGHT_LISTING_LOADER";
export const HIDE_RIGHT_LISTING_LOADER="HIDE_RIGHT_LISTING_LOADER";

export const SET_SELECTED_DIARY_DETAIL="SET_SELECTED_DIARY_DETAIL";

export const UPDATE_DIARY_VIEW_SUCCESS="UPDATE_DIARY_VIEW_SUCCESS";
export const UPDATE_DIARY_LIST_SUCCESS="UPDATE_DIARY_LIST_SUCCESS";

export const CREATE_DIARY_REQUEST = "CREATE_DIARY_REQUEST";
export const UPDATE_DIARY_REQUEST = "UPDATE_DIARY_REQUEST";
export const RESET_DIARY_FORM_DATA = "RESET_DIARY_FORM_DATA";
export const FETCH_DIARY_TAGS = "FETCH_DIARY_TAGS";
export const FETCH_DIARY_TAGS_SUCCESS = "FETCH_DIARY_TAGS_SUCCESS";